import type { NavPalette } from "@/components/design-switcher/nav-palette";

export const C = {
  flamenco: "#F05260",
  flamencoDark: "#C93E4B",
  flamencoDarker: "#9E2F3A",
  flamencoLight: "#F7A0A8",
  skyfall: "#84D5F7",
  skyfallDark: "#5EAFD4",
  skyfallDarker: "#3D8AB0",
  skyfallLight: "#B8E8FB",
  mintleaf: "#4EB969",
  mintleafDark: "#3A9450",
  mintleafDarker: "#2A7039",
  mintleafLight: "#8DD69C",
  plumwood: "#842885",
  plumwoodDark: "#661F67",
  plumwoodDarker: "#4C174D",
  plumwoodLight: "#B866B9",
  bg: "#F2F0EB",
  bgAlt: "#E8E5DE",
  black: "#1A1A1A",
  white: "#FFFFFF",
  shadow: "rgba(26,26,26,0.12)",
} as const;

export const nav: NavPalette = {
  surface: "rgba(242, 240, 235, 0.94)",
  surfaceHover: "rgba(232, 229, 222, 0.96)",
  border: "rgba(26, 26, 26, 0.22)",
  text: "#1A1A1A",
  textMuted: "rgba(26, 26, 26, 0.7)",
  activeBg: "rgba(132, 213, 247, 0.32)",
  activeText: "#1A1A1A",
};
